export const common = {
  topBar: {
    freeShipping: 'LIVRAISON GRATUITE - Sur toutes les commandes',
    newMemberDiscount: '10% de réduction pour les nouveaux membres',
    securePayment: 'Achat sécurisé',
  },
  header: { shopNow: 'Acheter Maintenant' },
  nav: {
    home: 'Accueil', women: 'FEMMES', men: 'HOMMES', blog: 'BLOG', superSale: 'SUPER SOLDES',
    memberLogin: 'Connexion membre', login: 'Se connecter', register: "S'inscrire",
    myOrders: 'Mes commandes', myFavorites: 'Mes favoris', myCart: 'Mon panier',
    pages: 'Pages', preferences: 'Préférences', myProfile: 'Mon Profil',
  },
  megaMenu: {
    womenCollection: 'Collection Femmes', menCollection: 'Collection Hommes', summerCollection: 'Collection Été 2025',
    viewAll: 'Voir tout', categories: 'CATÉGORIES', newSeason: 'NOUVELLE SAISON',
    upToDiscount: "Jusqu'à 70% de réduction", exploreAll: 'Explorer toute la collection',
    viewAllBtn: 'Voir tout', securePayment: 'Paiement sécurisé',
    sslNote: 'Tous vos paiements sont cryptés et sécurisés.', sslBadge: '256-bit SSL',
    quickTags: { newArrivals: 'Nouveautés', bestSelling: 'Meilleures ventes', discounted: 'Soldé', specialDesign: 'Design spécial' },
    womenSandals: 'Sandales Femmes', womenSandalsDesc: 'Collection été',
    womenClothing: 'Vêtements Femmes', womenClothingDesc: 'Pièces tendance',
    womenShoes: 'Chaussures Femmes', womenShoesDesc: 'Pour chaque style',
    womenBoots: 'Bottes Femmes', womenBootsDesc: 'Chic & solide',
    womenSlippers: 'Pantoufles Femmes', womenSlippersDesc: 'Confortable & stylé',
    womenBags: 'Sacs Femmes', womenBagsDesc: 'Favoris de la saison',
    womenAccessories: 'Accessoires Femmes', womenAccessoriesDesc: 'Pièces complémentaires',
    womenCombo: 'Combo Femmes', womenComboDesc: 'Ensembles complets',
    menSandals: 'Sandales Hommes', menSandalsDesc: 'Collection été',
    menClothing: 'Vêtements Hommes', menClothingDesc: 'Styles modernes',
    menShoes: 'Chaussures Hommes', menShoesDesc: 'Classique & sportif',
    menBoots: 'Bottes Hommes', menBootsDesc: 'Fort & stylé',
    menSlippers: 'Pantoufles Hommes', menSlippersDesc: 'Confort quotidien',
    menBags: 'Sacs Hommes', menBagsDesc: 'Travail & casual',
    menAccessories: 'Accessoires Hommes', menAccessoriesDesc: 'Détails de style',
    menCombo: 'Combo Hommes', menComboDesc: 'Ensembles complets',
    comboBadge: 'Combo', tshirt: 'T-Shirt', pants: 'Pantalons', dress: 'Robe', kimono: 'Kimono',
    crop: 'Crop', shirt: 'Chemise', skirt: 'Jupe', shorts: 'Shorts', suit: 'Costume', set: 'Set',
    womenLabel: 'Femmes', menLabel: 'Hommes', collectionSuffix: 'Collection',
  },
  topBarMessages: {
    msg1: 'LIVRAISON GRATUITE - Sur toutes les commandes | 10% de réduction pour les nouveaux membres',
    msg2: 'CHAUSSURES BAREFOOT DE MISE À LA TERRE ORGANIQUE BOTTES SANDALES',
    msg3: 'IL EST TEMPS DE VIVRE LA MODE ORGANIQUE — DÉCOUVREZ LA NATURALITÉ',
    msg4: 'SUPER COMBOS — NE MANQUEZ PAS LES CADEAUX SURPRISES AVANT RUPTURE DE STOCK',
  },
  quickMenu: {
    title: 'Accès rapide', liveChat: 'Chat en direct', liveChatStatus: 'Actif maintenant ✓',
    liveSupport: 'Support en direct', liveSupportStatus: 'Actif maintenant',
    liveCall: 'Appel en direct', liveCallDesc: 'Support vocal',
    liveBroadcast: 'Diffusion en direct', liveBroadcastStatus: 'En direct maintenant 🔴', liveBroadcastBadge: 'EN DIRECT',
    sustainability: 'Durabilité', sustainabilityDesc: '100% Bio 🌿',
    support247: 'Service client 24h/7j', scrollUp: 'Défiler vers le haut', menu: 'MENU', up: 'HAUT',
    dayMode: 'Jour',
    nightMode: 'Nuit',
    socialMedia: 'Réseaux Sociaux',
    pages: 'Pages',
    support: 'Support',
    followUs: 'Suivez-Nous',
    wholesale: 'Produits en Gros',
  },

  search: {
    placeholder: 'Rechercher des produits... (ex. sandales, bottes, robe)',
    noResults: 'Aucun résultat trouvé',
    viewAll: 'Voir tous les produits "{{query}}"',
    title: 'Recherche',
    shortLabel: 'Cherche',
    close: 'Fermer',
    popular: 'Recherches populaires',
    resultsLabel: 'Produits trouvés',
    popularTerms: ['Sandales', 'Bottes', 'Robe', 'Pantoufles', 'Combo'],
    searchPage: {
      resultsCount: 'produits trouvés',
      searchDesc: 'Trouvez le produit que vous cherchez',
      sortBy: 'Trier par',
      sortDefault: 'Par défaut',
      sortPriceLow: 'Prix: Bas à Élevé',
      sortPriceHigh: 'Prix: Élevé à Bas',
      sortDiscount: 'Réduction la plus élevée',
      viewProduct: 'Voir le produit',
      tryOtherTerms: 'Essayez un autre terme de recherche',
      loadMore: 'Charger plus',
    },
  },
  popularProductsNav: 'Produits populaires',
  settings: { language: 'Langue', currency: 'Devise', selectLanguage: 'Choisir la langue', selectCurrency: 'Choisir la devise' },
  marquee: { discount: '70% DE RÉDUCTION', combos: 'SUR LES COMBOS', summer: 'SPÉCIAL ÉTÉ' },
  home: {
    bestSeller: 'MEILLEURES VENTES', specialCampaign: 'CAMPAGNE SPÉCIALE',
    featuredCombos: 'Ensembles Combo en Vedette', featuredProducts: 'Produits en Vedette',
    exploreCategories: 'Explorer les Catégories', viewAllProducts: 'Voir Tous les Produits',
    viewAllCombos: 'Voir Tous les Combos', setContent: 'CONTENU DU SET',
    normalPrice: 'Prix Normal', comboPrice: 'Prix Combo', save: 'ÉCONOMIE',
    freeShippingBadge: 'Livraison Gratuite', viewDetails: 'Voir les Détails',
    whereToNextLabel: 'Collections', whereToNextTitle: 'Prochaine Destination?',
    whereToNextSubtitle: 'La seule chaussure dont vous avez besoin pour votre voyage!',
    whereToNextShop: 'Voir le produit', whereToNextBuy: 'ACHETER',
    flashSaleLabel: 'Vente Flash', flashSaleTitle: "Jusqu'à 70% de Réduction",
    flashSaleSubtitle: 'Stock limité — profitez-en vite!', flashSaleViewAll: 'Voir tout',
    flashSaleTimeLabel: 'La vente se termine dans', flashSaleHour: 'Heure',
    flashSaleMinute: 'Minute', flashSaleSecond: 'Seconde', flashSaleNext: 'Suivant:',
    flashSaleRound: 'Tour', flashSaleStockRunning: 'Stock épuisé', flashSaleSold: 'Vendu',
    flashSaleBuy: 'Acheter', flashSaleNewCampaign: 'Nouvelle vente commencée!',
    flashSaleNewCampaignSub: 'Ne manquez pas!',
    comboPacksTitle: 'Packs Combo', comboPacksSubtitle: "Économisez du temps et de l'argent",
    comboPacksIn: 'Contient:', comboPacksSaving: "d'économies!", comboPacksViewAll: 'Voir tous les combos',
    exploreCategoriesLabel: 'Collections', exploreCategoriesSubtitle: 'Choisissez la collection qui correspond à votre style',
    categoriesSubtitle: 'Choisissez la catégorie qui vous convient',
    catSlippers: 'Pantoufles', catSlippersSub: 'Modèles Confortables & Élégants',
    catSandals: 'Sandales', catSandalsSub: 'Modèles à Talons & Plats',
    catCombos: 'Tenues', catCombosSub: 'Combos 1+1 à partir de $500',
    catDresses: 'Robes', catDressesSub: 'Modèles Maxi, Midi & Mini',
    catVeganLeather: 'Cuir Vegan', catVeganLeatherSub: 'Collection Cruelty-Free',
    catGenuineLeather: 'Cuir Véritable', catGenuineLeatherSub: 'Produits en Cuir Animal Premium',
    catBadgeVegan: 'VEGAN', catBadgePremium: 'PREMIUM',
    recentReviewsTitle: 'Avis Clients Récents', recentReviewsSubtitle: 'Derniers avis de vrais acheteurs',
    recentReviewsViewAll: 'Tous les avis', recentReviewsAvgScore: 'Note Moyenne',
    recentReviewsTotal: 'Total des Avis', recentReviewsVerified: 'Acheteur Vérifié',
    recentReviewsVerifiedBadge: 'Vérifié', recentReviewsSizeLabel: 'Taille:',
    springBannerSubtitle: 'Découvrez les nouvelles collections de saison et complétez votre style',
    springCollectionsLabel: 'Collections',
    videoBannerLabel: 'Favoris des Clients', videoBannerTitle: 'Produits les Plus Appréciés',
    videoBannerSubtitle: 'Nos produits les plus aimés et les mieux notés',
    heroStartingFrom: 'À Partir De',
    blogBadge: 'Blog', blogTitle: 'Derniers Articles',
    blogSubtitle: 'Contenu inspirant sur la santé, la mode et la durabilité',
    blogViewAll: 'Voir tous les articles', blogReadMore: 'Lire la suite', blogReadTime: 'min de lecture',
    sustBannerBadge: 'Mode Durable', sustBannerTitle: 'Nous sommes défenseurs de',
    sustBannerTitleHighlight: 'la Durabilité & du Bio',
    sustBannerDesc: "Chaque couture, chaque teinture, chaque matériau — est l'expression de notre respect pour la planète et pour vous.",
    sustBannerStat1Label: "Moins d'eau", sustBannerStat2Label: 'Matériaux Bio', sustBannerStat3Label: 'Colorants Chimiques',
    sustBannerCta1: 'Notre Page Durabilité', sustBannerCta2: 'Collection Bio',
    sustPreviewBadge: 'Durabilité', sustPreviewTitle: 'De la Nature,', sustPreviewTitleHighlight: 'Retour à la Nature',
    sustPreviewSubtitle: "Chaque matériau, chaque étape de production et chaque emballage est la preuve de notre respect pour l'environnement.",
    sustPreviewViewAll: 'Voir la page complète', sustPreviewCta: 'Explorer notre philosophie durable',
    sustPreviewCertsLabel: 'Nos Certifications', sustPreviewCarbonLabel: 'Empreinte Carbone', sustPreviewCarbonVal: 'Zéro Émission',
    pcSlide1Tag: '⚡ NOUVELLE COLLECTION', pcSlide1Title: "Rêve d'Été", pcSlide1TitleHighlight: 'Collection',
    pcSlide1Subtitle: 'Sandales en cuir premium qui apportent la chaleur de la Méditerranée à vos pieds',
    pcSlide2Tag: '🔥 70% DE RÉDUCTION', pcSlide2Title: 'Boho Chic', pcSlide2TitleHighlight: "Robes d'Été",
    pcSlide2Subtitle: "Collection boho artisanale reflétant votre esprit libre — stock limité",
    pcSlide3Tag: '🌿 CUIR VEGAN', pcSlide3Title: 'Durable', pcSlide3TitleHighlight: 'Mode Luxe',
    pcSlide3Subtitle: 'Collection de cuir vegan premium, respectueuse de la nature et cruelty-free',
    pcSlide4Tag: '🍂 NOUVELLE COLLECTION', pcSlide4Title: 'Automne', pcSlide4TitleHighlight: 'Collection Bottes',
    pcSlide4Subtitle: "Ressentez l'esprit de l'automne avec des bottes en cuir artisanales — stock limité",
    pcSlide4Cta1: 'Bottes Femmes', pcSlide4Cta2: 'Bottes Hommes',
    mobileSlide1Title: '65% Réduction Mode Été', mobileSlide1Subtitle: "Jusqu'à 70% de Réduction sur les Tenues d'Été",
    mobileSlide2Title: 'Nouvelle Collection', mobileSlide2Subtitle: 'Modèles Sandales & Pantoufles en Cuir Premium',
    mobileSlide3Title: 'Collection Automne', mobileSlide3Subtitle: 'Bottes en Cuir Artisanales — Stock Limité',
    promoTitle: 'Combos 1+1', promoTitleHighlight: '70% de Réduction',
    promoSavings: 'Économisez $1 800!', promoCta: 'Explorer les Combos', promoDiscountBadge: "70% D'ÉCONOMIES",
    squareBanner1Label: 'NOUVELLE COLLECTION', squareBanner1Title: 'Collection\nÉtivale',
    squareBanner2Label: 'MEILLEURES VENTES', squareBanner2Title: 'Collection\nPantoufles',
    squareBanner3Label: 'TENDANCE ÉTÉ', squareBanner3Title: 'Collection\nSandales',
    squareBanner4Label: 'AUTOMNE', squareBanner4Title: 'Collection\nBottes',
    editorialBannersLabel: 'Nos Collections',
    editorialBannersTitle: 'Sabah Season is Coming',
    editorialBanner2Label: 'Meilleures Ventes',
    editorialBanner2Title: 'Pattern Babas',
    editorialBanner2Subtitle: 'De retour au Printemps',
    editorialBanner3Label: 'Voyage',
    editorialBanner3Title: 'Prochaine Destination?',
    editorialBanner3Subtitle: "La côte nord d'O'ahu",
    editorialBanner4Label: 'Fait Main',
    editorialBanner4Title: 'The Lido Sandal',
    editorialBanner4Subtitle: 'Fait à la main en Italie',
  },
  footer: {
    categories: 'Catégories', customerService: 'Service Client', followUs: 'Suivez-nous',
    wholesale: 'Vente en Gros', aboutUs: 'À Propos', contact: 'Contact', faq: 'FAQ',
    returnPolicy: 'Politique de Retour', privacyPolicy: 'Politique de Confidentialité',
    termsOfService: "Conditions d'Utilisation", shippingInfo: 'Informations de Livraison',
    paymentMethods: 'Modes de Paiement',
    tagline: 'Complétez votre style avec des produits de qualité et élégants.',
    womenClothing: 'Vêtements Femmes', womenShoes: 'Chaussures Femmes',
    menClothing: 'Vêtements Hommes', menShoes: 'Chaussures Hommes',
    comboPacks: 'Packs Combo', reviews: 'Avis', videos: 'Vidéos',
    popularProducts: 'Produits Populaires', sustainability: 'Durabilité',
    followUsDesc: 'Restez informé des nouvelles collections et campagnes.',
    copyright: '© 2024 FentyBarefoot. Tous droits réservés.',
    features: 'FONCTIONNALITÉS', featuresNew: 'NOUVEAU', sustainabilityLabel: 'DURABILITÉ',
    reviewsLabel: 'AVIS', reviewsNew: 'NOUVEAU', videosLabel: 'VIDÉOS', videosNew: 'NOUVEAU',
    returns: 'Retours & Échanges', sslShopping: 'Achat sécurisé avec SSL',
    women: 'Femmes', men: 'Hommes', company: 'Entreprise',
    womenSandals: 'Sandales Femmes', womenBoots: 'Bottes Femmes', womenSlippers: 'Pantoufles Femmes',
    womenBags: 'Sacs Femmes', womenAccessories: 'Accessoires Femmes', womenCombo: 'Combo Femmes',
    menSandals: 'Sandales Hommes', menBoots: 'Bottes Hommes', menSlippers: 'Pantoufles Hommes',
    menBags: 'Sacs Hommes', menAccessories: 'Accessoires Hommes', menCombo: 'Combo Hommes',
    termsConditions: "Conditions d'utilisation", privacyCookiePolicy: 'Confidentialité & Cookies',
    deliveryShipping: 'Livraison & Expédition', returnsExchanges: 'Retours & Échanges',
    allCategories: 'Toutes les catégories',
    addressesTitle: 'Nos Bureaux',
    trOfficeName: 'Siège Turquie', trOfficeAddrLine1: 'Şehitkamil Mah., İpek Yolu Cad. No: 127/A, Şehitkamil',
    trOfficeAddrLine2: '27500 Gaziantep, Turquie', trTaxNo: 'N° Fiscal : 1234567890',
    usOfficeName: 'Bureau USA', usOfficeAddrLine1: '1234 Broadway Avenue, Suite 500',
    usOfficeAddrLine2: 'New York, NY 10001, États-Unis', usTaxId: 'ID Fiscal : 98-7654321',
    returnPolicyBtn: 'Retours & Échanges', sitemap: 'Plan du Site',
    securePaymentTitle: 'Paiement Sécurisé',
    shippingPartnerTitle: 'Partenaire de Livraison',
    fastDelivery: 'Livraison Rapide',
    securityTitle: 'Sécurité',
    encryptedShopping: 'Achat Crypté',
    httpsSecure: 'HTTPS Sécurisé',
    intlShippingTitle: 'Pays — Livraison Internationale',
    intlShippingDesc: 'Livraison rapide et sécurisée dans le monde entier — suivi de commande inclus',
    cargoPartner: 'Partenaire Cargo',
    countries: 'Pays',
    businessDaysLabel: 'Jours Ouvrables',
    trackingLabel: 'Suivi',
    marketplaceTitle: 'Nous Vendons sur les Places de Marché Internationales',
    mobileShippingTitle: 'Pays Livraison Sécurisée',
    mobileShippingSubtitle: 'Suivi de commande · 3–7 jours ouvrés',
    mobileCargo: 'Cargo',
    mobileMarketplaceTitle: 'Marchés Internationaux',
    newsletterTitle: 'Abonnez-vous à notre newsletter',
    newsletterSubtitle: 'Soyez le premier informé des nouvelles collections, offres exclusives et promotions spéciales.',
    newsletterPlaceholder: 'Entrez votre adresse e-mail',
    newsletterSubscribe: "S'abonner",
    newsletterSuccess: 'Merci ! Vous vous êtes abonné avec succès. 🎉',
    newsletterPrivacy: 'Vos données sont en sécurité. Vous pouvez vous désabonner à tout moment.',
  },
  category: {
    filter: 'Filtrer', productsFound: 'produits trouvés', page: 'Page',
    otherCategories: 'Autres Catégories', showingProducts: 'produits affichés', of: 'sur',
    subcat: {
      all: 'Tout', boots: 'Bottes', clothing: 'Vêtements', shoes: 'Chaussures',
      sandals: 'Sandales', slippers: 'Pantoufles', bags: 'Sacs', accessories: 'Accessoires',
      combo: 'Ensembles Combo', tshirt: 'T-Shirt', pants: 'Pantalons', dress: 'Robe',
      kimono: 'Kimono', crop: 'Crop', shirt: 'Chemise', skirt: 'Jupe', shorts: 'Shorts', suit: 'Costume', set: 'Set',
    },
    meta: {
      women: 'Femmes', womenClothing: 'Vêtements Femmes', womenSandals: 'Sandales Femmes',
      womenSlippers: 'Pantoufles Femmes', womenShoes: 'Chaussures Femmes', womenBags: 'Sacs Femmes',
      womenAccessories: 'Accessoires Femmes', womenBoots: 'Bottes Femmes', womenCombo: 'Combos Femmes',
      tshirt: 'T-Shirt', pants: 'Pantalons', dress: 'Robe', kimono: 'Kimono', crop: 'Crop',
      shirt: 'Chemise', skirt: 'Jupe', shorts: 'Shorts', suit: 'Costume', set: 'Set',
      men: 'Hommes', menClothing: 'Vêtements Hommes', menSandals: 'Sandales Hommes',
      menSlippers: 'Pantoufles Hommes', menShoes: 'Chaussures Hommes', menBags: 'Sacs Hommes',
      menAccessories: 'Accessoires Hommes', menBoots: 'Bottes Hommes', menCombo: 'Combos Hommes',
      menTshirt: 'T-Shirt Hommes', menPants: 'Pantalons Hommes', menShirt: 'Chemise Hommes',
      menShorts: 'Shorts Hommes', menSuit: 'Costume Hommes',
      veganLeather: 'Cuir Vegan', genuineLeather: 'Cuir Véritable', combo: 'Combos',
    },
  },
  productPage: {
    notFound: 'Produit introuvable', backToHome: "Retour à l'accueil",
    reviews: 'avis', inStock: 'En stock', save: 'Économiser', comboContent: 'Contenu du combo',
    youSave: 'vous économisez', selectSize: 'Choisir la taille', sizeGuide: 'Guide des tailles',
    shoeSize: 'Choisir la pointure (US)', shoeSizeGuide: 'Guide des pointures',
    quantity: 'Quantité', addToCart: 'Ajouter au panier', added: 'Ajouté!',
    selectOptions: 'Faire une sélection!', buyNow: 'Acheter maintenant',
    freeShipping: 'Livraison gratuite', dayReturn: 'Retour 30 jours', securePayment: 'Paiement sécurisé',
    productDescription: 'Description du produit', features: 'Caractéristiques',
    similarProducts: 'Produits similaires', zoom: 'Zoom',
    zoomHint: 'Double-cliquez ou faites défiler pour zoomer',
    shopAnywhere: "Achetez ce produit de n'importe où", customerReviews: 'Avis clients',
    addedToCart: 'Produit ajouté au panier!', viewCart: 'Voir le panier', home: 'Accueil',
    personalization: 'Personnalisation & Emballage cadeau',
    personalizationNote: "Ajouter une note, choisir l'emballage cadeau", personalizationActive: 'Actif',
    shippingOption: 'Option de livraison', freeShippingLabel: 'Livraison gratuite', freeLabel: 'GRATUIT',
    estimatedDelivery: 'Livraison estimée:', businessDays: '(6 jours ouvrables)',
    customsTax: 'Droits de douane:', noExtraFee: 'Pas de frais supplémentaires, toutes taxes incluses!',
    missingSelection: 'Veuillez effectuer les sélections suivantes:', notSelected: 'non sélectionné',
    discount: 'RÉDUCTION', freeShippingBadge: 'LIVRAISON GRATUITE', selectColor: 'Choisir la couleur',
    sole: 'Choix Semelle', selectOption: 'Choisir une option', soleRubberGrounding: 'Caoutchouc + Mise à la Terre', soleRubberNoCopper: 'Caoutchouc (Sans Cuivre)', soleLeatherCopper: 'Semelle Cuir + Cuivre', soleLeatherNoCopper: 'Semelle Cuir (Sans Cuivre)', selected: 'Sélectionné:',
    women: 'Femmes', men: 'Hommes', selectNumber: 'Sélectionner une pointure',
    bestSellers: 'Produits les plus vendus', bestSellersSubtitle: 'Stars de la semaine',
    watchVideo: 'Regarder la vidéo', closeEsc: 'Appuyez sur ESC pour fermer',
    featureList: ['Matériau de qualité premium', 'Coupe et utilisation confortables', 'Durabilité longue durée', 'Entretien et nettoyage faciles', 'Diverses options de taille'],
    descriptionText1: "L'une des pièces phares de notre collection estivale, ce produit allie élégance et confort.",
    descriptionText2: 'Adapté à un usage quotidien, ce produit offre un look à la fois confortable et élégant.',
    featuresTitle: 'Caractéristiques',
    notSureAboutSize: 'Pas sûr de la taille?',
    fitOption: 'Option de coupe',
    wideFitLabel: 'Coupe large',
    wideFitDesc: 'Coupe confortable & détendue',
    narrowFitLabel: 'Coupe slim',
    narrowFitDesc: 'Coupe ajustée & slim',
    personalizationInlineTitle: 'Personnalisation',
    personalizationInlineLine1: 'Peut être porté sans chaussettes, confortable et sain.',
    personalizationInlineLine2: 'Pour des mesures précises, vous pouvez écrire vos mensurations de pied nu (longueur et largeur) en centimètres dans cette zone. Exemple (24,5 CM x 9 CM)',
    personalizationInlineLine3: 'Il sera fabriqué selon vos souhaits, large ou étroit.',
  },
  superSale: {
    limitedTime: 'Campagne à durée limitée', live: 'EN DIRECT', timeRemaining: 'Temps restant',
    all: 'Tout', women: 'Femmes', men: 'Hommes', womenCombo: 'Combo Femmes', menCombo: 'Combo Hommes',
    sortBy: 'Trier par', priceAsc: 'Prix: Bas à Élevé', priceDesc: 'Prix: Élevé à Bas',
    discountDesc: 'Réduction: Élevé à Bas', newest: 'Plus récent',
    productsOnSale: 'Produits en solde', totalDiscount: 'Réduction totale',
    happyCustomers: 'Clients satisfaits', freeShipping: 'Livraison gratuite',
    banner1Title: 'Meilleures offres de la saison', banner1Subtitle: "Jusqu'à 70% de réduction sur toutes les catégories",
    banner2Title: 'Dernières heures!', banner2Subtitle: "Ajoutez au panier avant qu'il ne soit trop tard",
    flashRound: 'Vente Flash', flashBadge: '⚡ FLASH', dailyRound: 'Offre du Jour',
    dailyBadge: '🔥 QUOTIDIEN', nightRound: 'Campagne Nuit', nightBadge: '🌙 NUIT',
    newCampaignStarted: 'Nouvelle campagne commencée!', dontMiss: 'Ne manquez pas!',
    nextCampaign: 'Suivant:', hours: 'HEURES', minutes: 'MINUTES', seconds: 'SECONDES',
    discount: 'RÉDUCTION', reviews: 'avis', stockStatus: 'État du stock', stockLeft: 'articles restants!',
  },
  combo: {
    title: 'Packs Combo',
    subtitle: "Économisez du temps et de l'argent avec des combos soigneusement préparés.",
    benefit1Title: 'Prix Avantageux', benefit1Desc: "20-30% moins cher qu'en achetant séparément",
    benefit2Title: 'Gain de Temps', benefit2Desc: "Expérience d'achat rapide avec des combos prêts",
    benefit3Title: 'Produits Compatibles', benefit3Desc: 'Combos soigneusement sélectionnés par des stylistes',
    comboBadge: 'Pack Combo', discountBadge: 'Réduction', packageContains: 'Contient:',
    savings: "d'économies!", filterAll: 'Tout', filterWomen: 'Femmes', filterMen: 'Hommes', giftProduct: 'Produit Cadeau',
  },
  blog: {
    title: 'Blog & Contenu', subtitle: 'Blog FentyBarefoot',
    heroSubtitle: 'Contenu informatif sur la santé des pieds, la philosophie barefoot, la mode durable et plus encore',
    all: 'Tout', healthLife: 'Santé & Vie', fashionTrend: 'Mode & Tendance',
    careCleaning: 'Soin & Nettoyage', sustainability: 'Durabilité', productKnowledge: 'Info produit',
    readMore: 'Lire la suite',
    newsletterTitle: 'Restez informé des nouvelles vidéos',
    newsletterDesc: 'Entrez votre e-mail pour être informé des nouveaux uploads.',
    newsletterPlaceholder: 'Votre adresse e-mail',
    subscribe: "S'abonner",
    post18Title: 'Mode Durable pour une Vie Naturelle',
    post18Excerpt: "L'importance des vêtements en coton bio, lin et matériaux recyclables, et les bienfaits de la consommation consciente.",
    post18Category: 'Durabilité',
    post18Date: '15 mars 2026',
    post18ReadTime: '6 min de lecture',
    post19Title: "Façons de Réduire Votre Empreinte Carbone",
    post19Excerpt: 'Méthodes pour réduire les émissions de carbone au quotidien, économies d\'énergie et habitudes de consommation responsable.',
    post19Category: 'Durabilité',
    post19Date: '20 mars 2026',
    post19ReadTime: '5 min de lecture',
    post20Title: 'Soutenir les Femmes et Enfants Touchés par la Guerre',
    post20Excerpt: 'Chaque achat crée un impact. Donner une partie du chiffre d\'affaires renforce la solidarité sociale.',
    post20Category: 'Responsabilité Sociale',
    post20Date: '25 mars 2026',
    post20ReadTime: '5 min de lecture',
    post21Title: 'Un Arbre pour Chacun: Avenir Vert',
    post21Excerpt: 'Contribuer à la nature à chaque achat et l\'importance des projets de reboisement.',
    post21Category: 'Environnement',
    post21Date: '1 avril 2026',
    post21ReadTime: '4 min de lecture',
    post22Title: "L'Histoire des Produits en Cuir Faits Main",
    post22Excerpt: 'Techniques de production traditionnelles, la valeur de l\'artisanat et des matériaux de qualité naturelle.',
    post22Category: 'Info Produit',
    post22Date: '5 avril 2026',
    post22ReadTime: '7 min de lecture',
    post23Title: 'Avantages des Tissus Biologiques pour la Santé',
    post23Excerpt: 'Les tissus biologiques sans produits chimiques réduisent le risque d\'allergie avec leurs propriétés bienveillantes pour la peau.',
    post23Category: 'Santé & Vie',
    post23Date: '10 avril 2026',
    post23ReadTime: '6 min de lecture',
    post24Title: "Production Neutre en Carbone: L'Engagement Environnemental de FentyBarefoot",
    post24Excerpt: "Processus de production neutres en carbone, utilisation d'énergie renouvelable et impact environnemental mesurable.",
    post24Category: 'Durabilité',
    post24Date: '12 avril 2026',
    post24ReadTime: '5 min de lecture',
    post25Title: 'Avenir Vert: Nous Plantons 50 000+ Arbres',
    post25Excerpt: 'Plus de 50 000 arbres plantés. Sensibilisation environnementale communautaire et notre vision de marque écologique.',
    post25Category: 'Environnement',
    post25Date: '18 avril 2026',
    post25ReadTime: '4 min de lecture',
    sustainabilityLabel: 'Durabilité',
    socialLabel: 'Responsabilité Sociale',
    environmentLabel: 'Environnement',
    sustainabilitySection: 'Durabilité & Vie Naturelle',
    newLabel: 'Nouveau',
    allPostsLabel: 'Tous les Articles',
    statFidan: 'Arbres Plantés',
    statCarbon: 'Carbone Réduit',
    statPeople: 'Personnes Touchées',
    statWaste: 'Déchets Recyclés',
    impactTitle: 'Avenir Vert: 50 000+ Arbres Plantés',
    impactDesc: 'Un arbre pour la nature à chaque achat. Avec nos clients, nous avons planté plus de 50 000 arbres à ce jour.',
  },
  filter: {
    filters: 'Filtres', clear: 'Effacer', sorting: 'Tri', popular: 'Plus populaire', newest: 'Plus récent',
    priceAsc: 'Prix: Bas à Élevé', priceDesc: 'Prix: Élevé à Bas', discount: 'Réduction la plus élevée',
    topRated: 'Mieux notés', priceRange: 'Fourchette de prix', size: 'Taille', color: 'Couleur',
    black: 'Noir', white: 'Blanc', camel: 'Camel', terracotta: 'Terracotta', beige: 'Beige',
    green: 'Vert', cream: 'Crème', brown: 'Marron', navy: 'Marine', olive: 'Vert olive',
    freeShipping: 'Livraison gratuite',
    rating: 'Évaluation', ratingAll: 'Toutes les notes', rating45plus: '4,5+ Étoiles',
    rating4plus: '4+ Étoiles', rating3plus: '3+ Étoiles',
    tags: 'Étiquettes', tagBestSeller: 'Meilleure vente', tagNewSeason: 'Nouvelle saison',
    tagOrganic: 'Biologique', tagVegan: 'Vegan', tagPremium: 'Premium', tagSpecialPrice: 'Prix spécial',
  },
  reviews: {
    title: 'Avis clients', reviewsCount: 'avis', writeReview: 'Écrire un avis',
    verified: 'Achat vérifié', size: 'Taille', helpful: 'Cet avis vous a-t-il été utile?',
    yourRating: 'Votre note', veryBad: 'Très mauvais', bad: 'Mauvais', average: 'Moyen', good: 'Bon', excellent: 'Excellent',
    yourName: 'Votre nom', namePlaceholder: 'Votre nom complet', purchasedSize: 'Taille achetée',
    selectSize: 'Sélectionner la taille (facultatif)', reviewTitle: "Titre de l'avis",
    titlePlaceholder: 'Résumez votre avis', yourReview: 'Votre avis',
    reviewPlaceholder: 'Partagez votre expérience du produit...',
    addPhotos: 'Ajouter des photos', maxPhotos: '(Maximum 5 photos)',
    photosSelected: 'photos sélectionnées. Survolez pour supprimer.',
    add: 'Ajouter', cancel: 'Annuler', submit: "Soumettre l'avis",
    submitted: 'Avis reçu!', submittedMessage: 'Il sera publié après examen. Merci!',
    customerFavorite: 'Favori des clients', filterAll: 'Tout', stars: 'Étoiles',
    sortNewest: 'Plus récent', sortHelpful: 'Plus utile', sortHighest: 'Note la plus élevée', sortLowest: 'Note la plus basse',
    noReviews: 'Aucun avis trouvé pour ce filtre.',
    noReviewsDesc: 'Aucun avis correspondant à vos filtres.', clearFiltersBtn: 'Effacer les filtres',
    viewProduct: 'Voir le produit', color: 'Couleur:',
    womenClothing: 'Vêtements Femme', womenShoes: 'Chaussures Femme',
    menClothing: 'Vêtements Homme', menShoes: 'Chaussures Homme',
    copyright: '© 2025 Organic Fashion. Tous droits réservés.', productReviewed: 'Produit évalué',
    sortLabel: 'Trier', allCategories: 'Toutes les catégories', moreFilters: 'Plus de filtres',
    featured: 'En vedette', reviewsShown: 'avis affichés', loadMore: 'Charger plus', allLoaded: 'Tous les avis chargés',
  },
  sizeGuide: {
    title: 'Guide des tailles', subtitle: 'Utilisez vos mesures pour trouver la bonne taille',
    women: 'Femmes', men: 'Hommes', kids: 'Enfants', size: 'Taille', bust: 'Poitrine',
    waist: 'Taille', hip: 'Hanches', height: 'Hauteur', howToMeasure: 'Comment mesurer?',
    bustMeasure: 'Mesure de la poitrine', bustDesc: 'Baissez vos bras, passez le ruban à travers le point le plus large.',
    waistMeasure: 'Mesure de la taille', waistDesc: 'Mesurez au point le plus étroit de votre taille.',
    hipMeasure: 'Mesure des hanches', hipDesc: "Mesurez horizontalement à l'endroit le plus large des hanches.",
    tip: 'Conseil', tipMessage: 'Si vous êtes entre deux tailles, choisissez la plus grande.',
    disclaimer: 'Les mesures sont approximatives et peuvent varier selon le produit.', gotIt: 'Compris',
    womenShoesLabel: 'Chaussures femmes été', menShoesLabel: 'Chaussures hommes été',
    womenClothingLabel: 'Vêtements femmes été', menClothingLabel: 'Vêtements hommes été',
    euColumn: 'Taille EU', usWomenColumn: 'US Femme', usMenColumn: 'US Homme', ukColumn: 'UK', footColumn: 'Pied', euLabel: 'EU',
    measureShoeTitle: 'Mesurer la longueur du pied',
    shoeStep1Title: 'Se mettre sur papier', shoeStep1Desc: 'Posez une feuille de papier blanc sur une surface plane. Retirez vos chaussettes et tenez-vous debout sur le papier.',
    shoeStep2Title: 'Tracer le pied', shoeStep2Desc: "Tracez soigneusement le contour de votre pied. Incluez le talon et le plus long orteil.",
    shoeStep3Title: 'Mesurer la longueur', shoeStep3Desc: "Mesurez la distance du talon à la pointe de votre plus long orteil en centimètres.",
    shoeStep4Title: 'Chercher dans le tableau', shoeStep4Desc: 'Trouvez votre mesure dans la colonne "Pied (cm)".',
    shoeTip: 'Si vos pieds ont des tailles différentes, prenez le plus grand.',
    measureClothingTitle: 'Prendre vos mensurations',
    bustDesc2: "Mesurer horizontalement à l'endroit le plus large de la poitrine.",
    waistDesc2: "Mesurer à l'endroit le plus étroit de la taille après avoir expiré.",
    hipDesc2: "Mesurer horizontalement à l'endroit le plus large des hanches.",
    heightDesc2: 'Mesurer du sommet de la tête à la plante des pieds.',
    clothingTip: 'Prenez vos mesures avec un ruban souple.',
    notSureTitle: 'Pas sûr?', notSureDesc: 'Si vous êtes entre deux tailles, choisissez la plus grande.',
    toleranceNote: 'Les mesures peuvent inclure une tolérance de ±1 cm.',
  },
  liveNotif: {
    bought: 'acheté', sandals: 'sandales achetées', slippers: 'pantoufles achetée',
    addedToFavorites: 'ajouté aux favoris', addedToCart: 'ajouté au panier',
    peopleFavorited: 'personnes ont ajouté aux favoris', inCart: 'dans le panier',
    stockRunning: 'Stock épuisé!', lastItems: 'Dernier', itemsLeft: 'articles restants!', live: 'En direct',
  },
  newsletter: {
    specialOffers: 'Offres spéciales', title: 'Rejoignez notre newsletter',
    description: 'Obtenez', discount: '10% de réduction',
    descriptionEnd: 'sur votre première commande! Soyez le premier informé des nouvelles collections.',
    emailPlaceholder: 'Votre adresse e-mail', subscribe: "S'abonner et économiser 10%",
    sending: 'Envoi en cours...', unsubscribe: 'Vous pouvez vous désabonner à tout moment.',
    thanks: 'Merci! 🎉', codeSent: 'Votre code de réduction de 10%a été envoyé à votre e-mail.',
    startShopping: 'Commencer les achats',
  },
  wholesale: {
    title: 'Vente en Gros', subtitle: 'Portail revendeur & grossiste',
    dealerLogin: 'Connexion revendeur', dealerApply: 'Demande de revendeur',
    dealerCode: 'Code revendeur / E-mail', dealerCodePlaceholder: 'Votre code revendeur ou e-mail',
    password: 'Mot de passe', login: 'Se connecter', notDealer: 'Pas encore revendeur?', apply: 'Postuler',
    fullName: 'Nom complet', fullNamePlaceholder: 'Nom complet', companyName: "Nom de l'entreprise",
    companyPlaceholder: "Nom de l'entreprise", email: 'E-mail', emailPlaceholder: 'entreprise@email.com',
    phone: 'Téléphone', phonePlaceholder: '+33 x xx xx xx xx', city: 'Ville', cityPlaceholder: 'Paris',
    taxNumber: 'Numéro fiscal', taxPlaceholder: 'Votre numéro fiscal', message: 'Votre message',
    messagePlaceholder: 'Présentez-vous brièvement ainsi que votre entreprise...',
    submitApplication: 'Soumettre la demande', submitting: 'Envoi en cours...',
    applicationReceived: 'Demande reçue!', contactSoon: 'Nous vous contacterons dès que possible.', close: 'Fermer',
  },
  login: {
    title: 'Connexion', email: 'E-mail', emailPlaceholder: 'exemple@email.com',
    password: 'Mot de passe', passwordPlaceholder: 'Entrez votre mot de passe',
    rememberMe: 'Se souvenir de moi', forgotPassword: 'Mot de passe oublié', loginButton: 'Se connecter',
    noAccount: 'Pas de compte?', signUp: "S'inscrire", orContinueWith: 'ou continuer avec',
    google: 'Continuer avec Google', welcome: 'Bon retour!', subtitle: 'Connectez-vous pour continuer vos achats',
    termsNote: 'En vous connectant, vous acceptez nos', termsLink: "Conditions d'utilisation",
    termsAnd: 'et', privacyLink: 'Politique de confidentialité', termsEnd: '.',
  },
  register: {
    title: "S'inscrire", name: 'Nom complet', namePlaceholder: 'Votre nom complet',
    email: 'E-mail', emailPlaceholder: 'exemple@email.com', password: 'Mot de passe',
    passwordPlaceholder: 'Créez un mot de passe fort', confirmPassword: 'Confirmer le mot de passe',
    confirmPasswordPlaceholder: 'Ressaisissez votre mot de passe',
    terms: "J'accepte les conditions d'utilisation", registerButton: "S'inscrire",
    haveAccount: 'Vous avez déjà un compte?', login: 'Se connecter',
    discount: '10% de réduction pour les nouveaux membres!',
    passwordStrength: { weak: 'Faible', medium: 'Moyen', strong: 'Fort' },
    sslNote: "Vos informations sont protégées en toute sécurité par SSL",
  },

  story: {
    swipeHint: 'Glisser',
    productTaggedLabel: 'produits étiquetés — appuyez pour explorer',
    goToProduct: 'Voir le produit',
    discountLabel: 'réduction',
    followInstagram: 'Suivre sur Instagram • @fentybarefoot',
    stories: {
      s1: { title: '🔥 Meilleures Ventes', subtitle: "Les stars de la semaine sont là — ne les manque pas!", badge: 'TOP VENTES', cta: 'Voir les populaires' },
      s2: { title: '✨ Sandales Nouvelle Saison 2026', subtitle: 'La nouvelle collection artisanale est arrivée', badge: 'NOUVELLE SAISON 2026', cta: 'Sandales Femmes' },
      s3: { title: '👗 Collection Femmes', subtitle: 'Allie élégance et liberté', badge: 'COLLECTION', cta: 'Mode Femme' },
      s4: { title: '🎉 Super Soldes', subtitle: "Jusqu\'à 70% de réduction — stocks limités!", badge: '70% DE RÉDUCTION', cta: 'Voir les offres' },
      s5: { title: '👟 Collection Hommes', subtitle: 'Style masculin moderne — naturel et confortable', badge: 'HOMMES', cta: 'Produits Hommes' },
      s6: { title: '🌿 Mode Durable', subtitle: 'Production éco-responsable, sensation de luxe', badge: 'ÉCO', cta: 'Notre Histoire' },
      s7: { title: '👜 Accessoires & Sacs', subtitle: 'Les détails qui complètent ton style', badge: 'NOUVEAU', cta: 'Collection Accessoires' },
      s8: { title: '🎁 Sets Combinés', subtitle: 'Plus avantageux ensemble — sets à prix spéciaux', badge: 'BON PLAN', cta: 'Découvrir les sets' },
      s9: { title: '📸 Nous sur Instagram', subtitle: '@fentybarefoot — Rejoins notre communauté', badge: 'SOCIAL', cta: 'Suivre sur Instagram' },
    },
  },

  fitGuide: {
    title: 'Guide des Coupes',
    subtitle: 'Comparez pour trouver la meilleure coupe',
    infoNote: 'En cas de doute, nous recommandons',
    infoHighlight: 'la Coupe Ample',
    infoNoteEnd: '— elle est libre sur le corps et convient à tout le monde.',
    wideLabel: 'Coupe Ample',
    wideFit: 'Confortable & Mouvement Libre',
    wideDesc: 'Une coupe respirante qui se pose librement sur le corps. Idéale pour un usage quotidien et les longues journées.',
    wideFeature1: 'Espace supplémentaire aux épaules et aux bras',
    wideFeature2: 'Taille détendue, coupe non restrictive',
    wideFeature3: 'Reste confortable pendant des heures',
    wideFeature4: 'Ne limite pas les mouvements',
    wideFeature5: 'Convient à tous les types de corps',
    wideBest: 'Usage quotidien, voyage, tenue décontractée',
    narrowLabel: 'Coupe Ajustée',
    narrowFit: 'Ajusté & Silhouette Chic',
    narrowDesc: 'Une coupe structurée et gainante qui met en valeur votre silhouette. Parfaite pour les occasions spéciales.',
    narrowFeature1: 'S\'ajuste parfaitement aux épaules et à la poitrine',
    narrowFeature2: 'Épouse doucement la taille',
    narrowFeature3: 'Look élégant et soigné',
    narrowFeature4: 'Souligne les contours du corps',
    narrowFeature5: 'Offre une silhouette fine et raffinée',
    narrowBest: 'Événements spéciaux, réunions professionnelles, dîners',
    compareTitle: 'Comparaison Rapide',
    featureHeader: 'Caractéristique',
    compareWide: 'Coupe Ample',
    compareNarrow: 'Coupe Ajustée',
    row1Label: 'Confort', row1Wide: '⭐⭐⭐⭐⭐', row1Narrow: '⭐⭐⭐⭐',
    row2Label: 'Silhouette', row2Wide: 'Fluide & Libre', row2Narrow: 'Définie & Ajustée',
    row3Label: 'Liberté de Mouvement', row3Wide: 'Maximum', row3Narrow: 'Modérée',
    row4Label: 'Meilleure Utilisation', row4Wide: 'Quotidien & Casual', row4Narrow: 'Spécial & Formel',
    row5Label: 'Adaptation au Corps', row5Wide: 'Tous types', row5Narrow: 'Selon la préférence',
    bestLabel: 'Idéal pour:',
    liveSupportText: 'Vous ne savez pas quelle coupe vous convient?',
    liveSupportLink: 'support en direct',
    liveSupportEnd: 'Notre équipe est là pour vous aider.',
    shoe: {
      title: 'Guide des Formes de Chaussures',
      subtitle: 'Choisissez la bonne forme selon la largeur des orteils',
      infoNote: 'Nos chaussures barefoot utilisent une',
      infoHighlight: 'forme anatomique',
      infoNoteEnd: '— les orteils s\'étalent naturellement sans compression.',
      barefootLabel: 'Forme Barefoot',
      barefootTagline: 'Anatomique & Bout Large',
      barefootDesc: 'Bout très large, coupe anatomique. Les orteils bougent librement sans serrement.',
      barefootF1: 'Bout le plus large disponible',
      barefootF2: 'Les orteils s\'étalent naturellement',
      barefootF3: 'Confort maximal toute la journée',
      barefootF4: 'Soutient la posture naturelle du pied',
      barefootBest: 'Usage quotidien, voyage, vie saine',
      standartLabel: 'Forme Standard',
      standartTagline: 'Normal & Équilibré',
      standartDesc: 'Coupe classique équilibrée avec un bout moyen — convient à la plupart des types de pieds.',
      standartF1: 'Bout de largeur moyenne',
      standartF2: 'Convient à de nombreuses formes de pieds',
      standartF3: 'Aspect élégant et polyvalent',
      standartF4: 'Idéal pour les pieds légèrement étroits',
      standartBest: 'Usage quotidien, travail, social',
      darLabel: 'Standard Étroit',
      darTagline: 'Étroit & Silhouette Élégante',
      darDesc: 'Bout étroit, coupe ajustée — conçu pour les pieds minces et longs.',
      darF1: 'Bout le plus étroit',
      darF2: 'Ajustement parfait pour pieds minces',
      darF3: 'Apparence élégante et raffinée',
      darF4: 'Idéal pour les occasions spéciales',
      darBest: 'Occasions spéciales, événements formels',
      toeGenis: 'Bout: Large',
      toeNormal: 'Bout: Normal',
      toeDar: 'Bout: Étroit',
      compareTitle: 'Comparaison des Formes',
      cmpToe: 'Bout',
      cmpToeBarefoot: 'Très Large',
      cmpToeStandart: 'Moyen',
      cmpToeDar: 'Étroit',
      cmpConfort: 'Confort',
      cmpUse: 'Utilisation',
      cmpUseBarefoot: 'Quotidien & Actif',
      cmpUseStandart: 'Quotidien & Chic',
      cmpUseDar: 'Spécial & Formel',
      cmpFit: 'Type de Pied',
      cmpFitBarefoot: 'Tous types, base large',
      cmpFitStandart: 'Pied standard',
      cmpFitDar: 'Pied mince & long',
    },
  },

  careGuide: {
    tabDescription: 'Description du Produit',
    tabMaterial: 'Info Tissu',
    tabCare: 'Instructions d\'Entretien',
    tabLeather: 'Soin du Cuir',
    tabSole: 'Caractéristiques Semelle',
    compositionTitle: 'Composition du Matériau',
    mainFabricLabel: 'Tissu Principal',
    mainFabricVal: '100% Lin Biologique',
    liningLabel: 'Doublure',
    liningVal: '100% Coton Biologique',
    certLabel: 'Certification',
    certVal: 'Certifié GOTS Biologique',
    propertiesTitle: 'Propriétés du Tissu',
    prop1: 'Structure respirante et légère',
    prop2: 'Propriétés absorbantes',
    prop3: 'Structure en fil naturel, hypoallergénique',
    prop4: 'Résistant aux UV, longue durée',
    prop5: 'Respectueux de l\'environnement, d\'origine naturelle',
    washLabel: 'Lavage',
    washVal: '30°C Délicat',
    washNote: 'Laver à l\'eau froide en programme délicat',
    dryLabel: 'Séchage',
    dryVal: 'Séchage à l\'Air',
    dryNote: 'Sécher à l\'ombre, milieu naturel',
    ironLabel: 'Repassage',
    ironVal: 'Chaleur Moyenne ••',
    ironNote: 'Utiliser un chiffon humide ou fer à vapeur',
    bleachLabel: 'Blanchiment',
    bleachVal: 'Sans Chlore',
    bleachNote: 'Utiliser détergent doux à base d\'oxygène',
    dryCleanLabel: 'Nettoyage à Sec',
    dryCleanVal: 'Non Recommandé',
    dryCleanNote: 'Ne pas nettoyer à sec',
    tipsTitle: 'Conseils d\'Entretien d\'Expert',
    tip1: 'Légère décoloration possible au premier lavage — laver séparément',
    tip2: 'Les légères faux plis sur lin sont normaux — repasser à la vapeur',
    tip3: 'Laver les couleurs foncées à l\'envers',
    tip4: 'Ne pas mettre au sèche-linge — la forme peut se déformer',
    orgCertNote: 'Qu\'est-ce que la Certification GOTS?',
    orgCertDesc: 'Global Organic Textile Standard — la norme biologique la plus stricte du secteur textile, couvrant l\'ensemble du processus de production.',
    leatherWarningTitle: 'Avertissement Semelle Cuir',
    leatherWarningText: 'Les semelles en cuir ne conviennent pas à une humidité excessive. Un contact prolongé avec la pluie, les flaques ou les surfaces mouillées peut endommager le cuir.',
    rubberTitleSection: 'Semelle Caoutchouc — Sûre par Tous les Temps',
    rubberDesc: 'Les semelles en caoutchouc résistent à l\'eau, au froid hivernal et aux surfaces dures. Le choix idéal pour la pluie, la neige et les terrains difficiles.',
    leatherCare1Label: 'Humidité',
    leatherCare1Val: 'Protéger',
    leatherCare1Note: 'Éloigner de la pluie et de l\'eau',
    leatherCare2Label: 'Nettoyage',
    leatherCare2Val: 'Chiffon Humide',
    leatherCare2Note: 'Éviter les détergents forts',
    leatherCare3Label: 'Stockage',
    leatherCare3Val: 'Ventilé',
    leatherCare3Note: 'Éloigner du soleil direct',
    leatherCare4Label: 'Conditionneur',
    leatherCare4Val: 'Recommandé',
    leatherCare4Note: 'Utiliser crème nourrissante',
    leatherCare5Label: 'Séchage',
    leatherCare5Val: 'Séchage Air',
    leatherCare5Note: 'Pas de chaleur ni sèche-cheveux',
    leatherTipsTitle: 'Conseils Soin du Cuir',
    leatherTip1: 'Ne jamais exposer le cuir mouillé à la chaleur directe — sécher à l\'ombre naturellement',
    leatherTip2: 'Appliquer une crème nourrissante ou huile naturelle une fois par mois',
    leatherTip3: 'Ranger dans un sac à poussière quand inutilisé',
    leatherTip4: 'Essuyer immédiatement les taches avec un chiffon humide',
    soleFeature1Title: 'Semelle Cuir',
    soleFeature1Badge: 'Classique & Naturelle',
    soleFeature1Desc: 'Semelle en cuir véritable artisanale — respirante, se moule au pied et développe du caractère.',
    soleFeature1Pro1: 'Respirant et sensation naturelle',
    soleFeature1Pro2: 'S\'adapte à la forme du pied',
    soleFeature1Pro3: 'Apparence élégante et raffinée',
    soleFeature1Con1: 'Éviter l\'exposition excessive à l\'humidité',
    soleFeature2Title: 'Semelle Caoutchouc',
    soleFeature2Badge: 'Durable & Tous Temps',
    soleFeature2Desc: 'Semelle en caoutchouc antidérapante offrant une excellente adhérence sur surfaces mouillées, froides et dures.',
    soleFeature2Pro1: 'Résistant à l\'eau et à l\'hiver',
    soleFeature2Pro2: 'Sécurité antidérapante sur surfaces dures',
    soleFeature2Pro3: 'Convient aux quatre saisons',
    soleFeature3Title: 'Cuivre + Mise à la Terre',
    soleFeature3Badge: 'Effet Grounding',
    soleFeature3Desc: 'Les détails conducteurs en cuivre créent une connexion de mise à la terre avec la terre à chaque pas.',
    soleFeature3Pro1: 'Effet de mise à la terre scientifique',
    soleFeature3Pro2: 'Sentez l\'énergie de la terre',
    soleFeature3Pro3: 'Contribue à la réduction du stress',
    soleCompareTitle: 'Comparaison des Semelles',
    soleCompareName: 'Caractéristique',
    soleCompareWater: 'Résistance à l\'eau',
    soleCompareWinter: 'Performance hivernale',
    soleCompareGrip: 'Adhérence au sol',
    soleCompareBreath: 'Respirabilité',
    soleCompareGrounding: 'Mise à la Terre',
  },

  productFAQ: {
    badge: 'FAQ Produit',
    title: 'Questions Fréquentes',
    subtitle: 'Les questions les plus fréquentes sur ce produit',
    q1: 'Comment trouver ma taille?',
    a1: 'Nous recommandons d\'utiliser notre guide des tailles. Si vous êtes entre deux tailles, choisissez la plus grande — retours et échanges gratuits disponibles.',
    q2: 'Quels matériaux sont utilisés?',
    a2: 'Nos produits sont fabriqués à partir de lin et coton biologique certifié GOTS. Aucun colorant chimique — matériaux naturels, hypoallergéniques et durables.',
    q3: 'Quand ma commande arrivera-t-elle?',
    a3: 'Votre commande est préparée en 1-2 jours ouvrables. 3-5 jours en Turquie, 6-12 jours internationalement. Livraison gratuite applicable.',
    q4: 'Puis-je retourner le produit?',
    a4: 'Oui! Retours gratuits dans les 30 jours. Nous couvrons les frais de retour. Produit non utilisé, étiquettes intactes et emballage d\'origine.',
    q5: 'Quelle semelle choisir?',
    a5: 'Pour usage quotidien et estival, la semelle cuir est un choix élégant et naturel. Pour conditions pluvieuses, hivernales ou terrains difficiles, la semelle caoutchouc est plus durable. Pour la mise à la terre, choisissez Cuivre + Grounding.',
    q6: 'Coupe ample ou ajustée?',
    a6: 'En cas de doute, nous recommandons la coupe ample — se pose librement, convient à toutes les morphologies et reste confortable toute la journée.',
    q7: 'Comment prendre soin du produit?',
    a7: 'Lavage machine en programme délicat à 30°C. Les légères grincements dans le lin sont normaux — vapeur. Utiliser détergent sans chlore et sécher à l\'air.',
    q8: 'Puis-je personnaliser ma commande?',
    a8: 'Absolument! Vous pouvez ajouter un nom personnalisé, un message ou une préférence de couleur. Des options d\'emballage cadeau sont également disponibles.',
    ctaTitle: 'D\'autres questions?',
    ctaDesc: 'Notre équipe de support est disponible 24h/24.',
    ctaBtn: 'Support en Direct',
  },
  relatedProducts: {
    title: 'Produits Similaires',
    subtitle: 'Alternatives de la même catégorie que vous pourriez aimer',
    freeShipping: 'Gratuit',
    sold: 'vendus',
    viewProduct: 'Voir le produit',
    viewAll: 'Voir tous les produits',
  },
  alsoBought: {
    title: 'Les clients ont aussi acheté',
    subtitle: 'Les produits les plus appréciés par les clients ayant acheté cet article',
    liveBadge: 'Tendance maintenant',
    trending: 'Tendance',
    soldTogether: 'personnes ont acheté ensemble',
    quickView: 'Aperçu rapide',
    quickViewLabel: 'Aperçu rapide',
    added: 'Ajouté',
    trustSecure: 'Paiement sécurisé',
    trustShipping: 'Livraison gratuite',
    trustReturn: 'Retour 30 jours',
    qvDiscount: 'Réduction',
    qvSave: 'Économie',
    qvReviews: 'avis',
    qvAddToCart: 'Ajouter au panier',
    qvGoToProduct: 'Aller à la page produit',
    qvNote: 'Visitez la page produit pour toutes les options et détails.',
  },
  igPopup: {
    title: '🎉 Obtenez -60%',
    description: 'Suivez-nous sur Instagram, aimez 3 publications, commentez 3 publications, puis envoyez "CODE" en DM!',
    step1: 'Suivez-nous: @zenciv.store',
    step2: 'Aimer 3 publications',
    step3: 'Commenter 3 publications',
    step4: 'Envoyer "CODE" en DM',
    usernamePlaceholder: 'Votre nom d\'utilisateur Instagram',
    emailPlaceholder: 'Votre adresse e-mail',
    goToInstagram: 'Aller sur Instagram',
    completed: 'J\'ai terminé – Envoyer DM',
    sending: 'Envoi en cours...',
    trustNote: 'Zéro spam. Uniquement des réductions et mises à jour.',
    errorInstagram: 'Le nom d\'utilisateur Instagram est requis.',
    errorEmail: 'Veuillez entrer une adresse e-mail valide.',
    successTitle: 'Super, merci !',
    successText: 'Une fois votre activité vérifiée, nous vous enverrons votre code -60% par DM.',
    successDiscount: 'Code -60% envoyé par DM',
    sendDM: 'Envoyer DM',
    continueShopping: 'Continuer les achats',
    neverShow: 'Ne plus afficher',
  },

  barefootHealth: {
    badgeLabel: 'Approuvé par Podiatre',
    verified: 'Recherche Scientifique',
    title: 'Avantages Santé du Barefoot',
    subtitle: 'Technologie barefoot recommandée par les podiatres — le choix le plus naturel pour vos pieds.',
    more: 'de plus',
    cta: 'Voir Tous les Avantages Santé',
    popupTitle: 'Avantages Santé de la Technologie Barefoot',
    popupSubtitle: 'La science rencontre la nature — avantages prouvés pour la santé de vos pieds',
    podiatrist: 'Podologue',
    benefitsTitle: '6 Avantages Santé Essentiels',
    benefits: [
      'Écartement Naturel des Orteils',
      'Équilibre & Coordination Améliorés',
      'Renforcement Musculaire',
      'Santé Articulaire',
      'Posture de Marche Naturelle',
      'Adaptation au Sol',
    ],
    benefitDescs: [
      'La large boîte à orteils permet aux orteils de s\'écarter naturellement dans leur position anatomique.',
      'La semelle minimale augmente la proprioception, améliorant l\'équilibre et la coordination.',
      'Les muscles du pied, du mollet et de la hanche travaillent plus naturellement et se renforcent.',
      'La pression articulaire réduite soutient la santé des genoux et des hanches à long terme.',
      'L\'impact du talon est réduit, favorisant une foulée naturelle sur l\'avant-pied.',
      'Le ressenti du sol augmente, développant la connexion cerveau-pied.',
    ],
    doctorQuote: 'Les chaussures barefoot figurent parmi les options les plus anatomiquement appropriées pour le pied. La large boîte à orteils permet un écartement naturel tandis que la semelle minimale améliore la proprioception. À long terme, cela peut prévenir les oignons, les orteils en marteau et la fasciite plantaire.',
    warningsTitle: 'Risques des Chaussures Traditionnelles',
    warnings: [
      'La compression des orteils peut causer des oignons et orteils en marteau',
      'Les talons hauts perturbent le centre de gravité du corps',
      'Un soutien excessif affaiblit les muscles du pied',
      'La boîte à orteils étroite peut provoquer une compression nerveuse',
      'Les semelles épaisses bloquent le retour sensoriel du sol',
      'Des troubles de la marche à long terme peuvent se développer',
    ],
    anatomyTitle: 'Barefoot vs Traditionnel : Comparaison Anatomique',
    anatomyBarefoot: 'Barefoot — Naturel & Sain',
    anatomyTraditional: 'Traditionnel — Compression & Pression',
  },

  groundingSole: {
    headerTitle: 'Semelle Cuivre + Mise à la Terre',
    headerSubtitle: 'Connexion énergétique avec la nature à chaque pas',
    scienceBadge: 'Preuve Scientifique',
    diagramFoot: 'Pied',
    diagramCopper: 'Fil de Cuivre',
    diagramIons: 'Ions Négatifs',
    diagramSole: 'Semelle Cuivre',
    diagramEarth: 'Connexion Terre',
    howItWorks: 'Comment ça fonctionne ?',
    step1Title: 'Conductivité du Cuivre',
    step1Desc: 'De fins fils de cuivre dans la semelle connectent votre pied directement au champ électromagnétique de la terre. Le cuivre est l\'un des meilleurs conducteurs naturels.',
    step2Title: 'Contact avec le Sol',
    step2Desc: 'Lorsque la semelle touche le sol en marchant, le flux d\'électrons libres commence — l\'équivalent scientifique de marcher pieds nus sur terre naturelle.',
    step3Title: 'Flux d\'Ions Négatifs',
    step3Desc: 'Les ions négatifs passant du sol dans le corps neutralisent les radicaux libres, réduisant l\'inflammation et soutiennent l\'énergie cellulaire.',
    benefitsTitle: 'Bienfaits pour la Santé',
    benefit1: 'Réduit l\'inflammation',
    benefit2: 'Améliore la qualité du sommeil',
    benefit3: 'Neutralisation des radicaux libres',
    benefit4: 'Réduit stress & cortisol',
    benefit5: 'Améliore la circulation',
    benefit6: 'Soutien du système immunitaire',
    stat1: 'Études Scientifiques',
    stat2: 'Utilisateurs Satisfaits',
    stat3: 'Ont Ressenti une Différence',
    quoteText: 'La mise à la terre stabilise électriquement le corps. Je la considère comme une intervention naturelle contre l\'inflammation chronique, le stress et les troubles du sommeil.',
    quoteAuthor: 'Dr. Marie Dubois',
    quoteRole: 'Podologue & Spécialiste en Santé du Pied',
  },
  sustainabilitySpeech: {
    lang: 'fr-FR',
    title: 'Durabilité & Mise à la terre — Narration audio',
    playLabel: 'Écouter la narration audio',
    stopLabel: 'Arrêter',
    text: `Bienvenue dans la boutique de mode biologique FentyBarefoot. Notre philosophie de durabilité et de vie naturelle.

Vivre en harmonie avec la nature n'est pas un choix — c'est une responsabilité. Nous préconisons de revenir à l'essence de l'humanité, au rythme de la nature et aux véritables besoins du corps, sans se laisser emporter par la vitesse du monde moderne. Chaque produit que nous créons est le reflet de cette philosophie.

L'effet du contact avec la terre sur le corps humain est connu depuis des siècles. C'est pourquoi nos chaussures de mise à la terre ne sont pas seulement des chaussures — elles sont un moyen de se reconnecter avec la nature. Grâce à la structure spéciale de semelle conductrice, elles aident à équilibrer l'énergie naturelle du corps, offrant confort et conscience tout au long de la journée.

Nos Chaussures de Mise à la Terre. Les matériaux sont soigneusement sélectionnés. Cuir naturel et surfaces respirantes. Structure de semelle conductrice. Détails faits à la main. Matériaux traités avec un minimum de produits chimiques. Chaque paire est produite en tenant compte de votre santé et de notre planète.

Textiles Naturels et Biologiques. Les produits en coton et en lin de notre collection sont fabriqués à partir de fibres cent pour cent naturelles. Ils sont respirants et respectueux de la peau. Ils ne contiennent pas de produits chimiques synthétiques. Ils ont des designs durables et intemporels.

Notre Politique de Durabilité. La durabilité n'est pas une tendance pour nous — c'est le fondement de la production. Production selon le principe du faible gaspillage. Matières premières respectueuses de la nature. Production artisanale avec des artisans locaux. Emballage minimal et recyclable. Logistique consciente et optimisée.

Pourquoi Nous? Parce que nous ne vendons pas seulement des produits. Nous offrons un style de vie. Nous priorisons la naturalité et la simplicité. Nous plaçons la qualité avant la consommation rapide.

Nous croyons qu'il est possible de consommer moins mais mieux. Nous vous invitons à ce voyage de retour à la nature, pour écouter votre corps et découvrir le vrai confort.`,
  },
  aboutUs: {
    title: 'À Propos de Nous',
    subtitle: 'La vraie essence du barefoot',
    text: 'FentyBarefoot est la marque de référence pour le barefoot et la mode durable. Nous croyons en la force d\'un pied naturellement nu et en la beauté d\'une chaussure qui respecte la nature.',
    missionTitle: 'Notre Mission',
    missionText: 'Notre mission est de créer des chaussures qui offrent le confort et la performance du barefoot tout en respectant la nature et la durabilité.',
    visionTitle: 'Notre Vision',
    visionText: 'Notre vision est de créer un monde où la mode et la nature coexistent en harmonie.',
    teamTitle: 'Notre Équipe',
    teamText: 'Notre équipe est composée de designers, de chaussiers et de passionnés de la nature.',
    valuesTitle: 'Nos Valeurs',
    valuesText: 'Transparence, Éthique, Durabilité, Simplicité.',
    contactTitle: 'Nous Contacter',
    contactText: 'Vous pouvez nous contacter à l\'adresse suivante: info@fentybarefoot.com',
    breadcrumb: 'À propos de nous',
    noWarBadge: 'Une Position pour la Paix',
    noWarTitle: 'Non à la Guerre, Oui à la Vie',
    noWarSubtitle: "Nous ne soutenons aucune mort humaine. Nous nous opposons aux armes chimiques et à toute action qui perturbe l'équilibre de la nature.",
    noWarP1: "La vraie durabilité exige de s'opposer à tout préjudice que les humains s'infligent mutuellement et à la nature. C'est pourquoi nous déclarons ouvertement notre opposition à la guerre, à la violence et aux armes chimiques.",
    noWarP2: "Les armes chimiques polluent le sol, l'eau et l'air. S'opposer à ces outils qui perturbent l'atmosphère et privent les êtres vivants de leur droit à la vie fait partie intégrante de notre respect pour notre planète.",
    noWarP3: "Chez FentyBarefoot, nous portons cette croyance dans chaque produit et travaillons à laisser un monde pacifique et vert aux générations futures.",
    noWarStat1: 'Anti-guerre',
    noWarStat2: 'Contre les armes chimiques',
    noWarStat3: 'Défenseur de la nature',
    noWarStat4: 'Défenseur de la vie',
    noWarQuote: "Il n'y a pas de durabilité sans paix. Se dresser contre tout ce qui nuit à l'humanité et à la nature est à la fois une responsabilité éthique et écologique.",
  },
  personalization: {
    title: 'Personnalisation',
    subtitle: 'Personnalisez votre chaussure',
    description: 'Personnalisez votre chaussure avec nos options de personnalisation',
    personalizationNote: "Ajouter une note, choisir l'emballage cadeau",
    personalizationActive: 'Actif',
    shippingOption: 'Option de livraison',
    freeShippingLabel: 'Livraison gratuite', freeLabel: 'GRATUIT',
    estimatedDelivery: 'Livraison estimée:', businessDays: '(6 jours ouvrables)',
    customsTax: 'Droits de douane:', noExtraFee: 'Pas de frais supplémentaires, toutes taxes incluses!',
    missingSelection: 'Veuillez effectuer les sélections suivantes:', notSelected: 'non sélectionné',
    discount: 'RÉDUCTION', freeShippingBadge: 'LIVRAISON GRATUITE', selectColor: 'Choisir la couleur',
    sole: 'Choix Semelle', selectOption: 'Choisir une option', soleRubberGrounding: 'Caoutchouc + Mise à la Terre', soleRubberNoCopper: 'Caoutchouc (Sans Cuivre)', soleLeatherCopper: 'Semelle Cuir + Cuivre', soleLeatherNoCopper: 'Semelle Cuir (Sans Cuivre)', selected: 'Sélectionné:',
    women: 'Femmes', men: 'Hommes', selectNumber: 'Sélectionner une pointure',
    bestSellers: 'Produits les plus vendus', bestSellersSubtitle: 'Stars de la semaine',
    watchVideo: 'Regarder la vidéo', closeEsc: 'Appuyez sur ESC pour fermer',
    featureList: ['Matériau de qualité premium', 'Coupe et utilisation confortables', 'Durabilité longue durée', 'Entretien et nettoyage faciles', 'Diverses options de taille'],
    descriptionText1: "L'une des pièces phares de notre collection estivale, ce produit allie élégance et confort.",
    descriptionText2: 'Adapté à un usage quotidien, ce produit offre un look à la fois confortable et élégant.',
    featuresTitle: 'Caractéristiques',
    notSureAboutSize: 'Pas sûr de la taille?',
    fitOption: 'Option de coupe',
    wideFitLabel: 'Coupe large',
    wideFitDesc: 'Coupe confortable & détendue',
    narrowFitLabel: 'Coupe slim',
    narrowFitDesc: 'Coupe ajustée & slim',
    personalizationInlineTitle: 'Personnalisation',
    personalizationInlineLine1: 'Peut être porté sans chaussettes, confortable et sain.',
    personalizationInlineLine2: 'Pour des mesures précises, vous pouvez écrire vos mensurations de pied nu (longueur et largeur) en centimètres dans cette zone. Exemple (24,5 CM x 9 CM)',
    personalizationInlineLine3: 'Il sera fabriqué selon vos souhaits, large ou étroit.',
  },
  personalizationInlineTitle: 'Personnalisation',
  personalizationInlineLine1: 'Peut être porté sans chaussettes, confortable et sain.',
  personalizationInlineLine2: 'Pour des mesures précises, vous pouvez écrire vos mensurations de pied nu (longueur et largeur) en centimètres dans cette zone. Exemple (24,5 CM x 9 CM)',
  personalizationInlineLine3: 'Il sera fabriqué selon vos souhaits, large ou étroit.',
  measureGuide: {
    btnLabel: 'Guide de Mesure',
    title: 'Guide de Mesure du Pied',
    subtitle: 'Mesure pieds nus — en cm',
    diagramLabel: 'Diagramme de Mesure',
    lengthLabel: 'LONGUEUR',
    widthLabel: 'LARGEUR',
    toeWidthLabel: 'LARG. ORTEILS',
    example: 'Exemple:',
    stepsTitle: 'Comment Mesurer?',
    step1Title: 'Poser du papier blanc',
    step1Desc: 'Posez une feuille de papier blanc sur une surface plane. Retirez vos chaussettes et tenez-vous debout sur le papier.',
    step2Title: 'Tracer le pied',
    step2Desc: 'En tenant le stylo droit, tracez soigneusement le contour de votre pied. Incluez le talon et le plus long orteil.',
    step3Title: 'Mesurer la longueur',
    step3Desc: 'Mesurez la distance du talon à la pointe de votre plus long orteil en centimètres.',
    step4Title: 'Mesurer la largeur',
    step4Desc: 'Mesurez au point le plus large de votre pied (au niveau de la boule du pied).',
    tipLabel: 'Conseil:',
    tip: 'Si vos pieds sont de tailles différentes, utilisez le plus grand. Entrez votre mesure dans le champ de personnalisation au format "24,5 CM × 9 CM".',
    gotIt: 'Compris, Fermer',
  },

  categories: {
    'women-clothing': 'Vêtements Femme',
    'women-shoes': 'Chaussures Femme',
    'women-slippers': 'Chaussons Femme',
    'women-sandals': 'Sandales Femme',
    'women-combo': 'Combos Femme',
    'women-clothing-tshirt': 'T-Shirts Femme',
    'women-clothing-pants': 'Pantalons Femme',
    'women-clothing-dress': 'Robes Femme',
    'women-clothing-kimono': 'Kimonos Femme',
    'women-clothing-crop': 'Crop Tops Femme',
    'women-clothing-shirt': 'Chemisiers Femme',
    'women-clothing-skirt': 'Jupes Femme',
    'women-clothing-shorts': 'Shorts Femme',
    'women-clothing-set': 'Ensembles Femme',
    'women-clothing-suit': 'Tailleurs Femme',
    'men-clothing': 'Vêtements Homme',
    'men-shoes': 'Chaussures Homme',
    'men-slippers': 'Chaussons Homme',
    'men-sandals': 'Sandales Homme',
    'men-combo': 'Combos Homme',
    'men-clothing-tshirt': 'T-Shirts Homme',
    'men-clothing-pants': 'Pantalons Homme',
    'men-clothing-shirt': 'Chemises Homme',
    'men-clothing-shorts': 'Shorts Homme',
    'men-clothing-suit': 'Costumes Homme',
    combo: 'Sets Combo',
    women: 'Femme',
    men: 'Homme',
    'vegan-leather': 'Cuir Vegan',
    'genuine-leather': 'Cuir Véritable',
  },
  checkout: {
    breadcrumbHome: 'Accueil',
    breadcrumbCheckout: 'Paiement',
    pageTitle: 'Paiement Sécurisé',
    pageSubtitle: 'Toutes vos informations sont protégées par SSL',
    ssl: '256-bit SSL',
    secure3d: '3D Secure',
    pciDss: 'PCI DSS',
    customerTitle: 'Informations Client',
    guestContinue: 'Continuer comme invité',
    memberLogin: 'Connexion membre',
    guestInfo: 'Vous pouvez passer une commande en tant qu\'invité.',
    register: 'S\'inscrire',
    firstName: 'Prénom',
    firstNamePlaceholder: 'Votre prénom',
    lastName: 'Nom',
    lastNamePlaceholder: 'Votre nom de famille',
    email: 'E-mail',
    emailPlaceholder: 'exemple@email.com',
    phone: 'Téléphone',
    phonePlaceholder: '+33 X XX XX XX XX',
    password: 'Mot de passe',
    passwordPlaceholder: '••••••••',
    loginButton: 'Se connecter',
    noAccount: 'Pas de compte?',
    required: '*',
    addressTitle: 'Adresse de livraison',
    address: 'Adresse',
    addressPlaceholder: 'Rue, numéro, appartement...',
    city: 'Ville',
    cityPlaceholder: 'Paris',
    postalCode: 'Code postal',
    postalCodePlaceholder: '75001',
    country: 'Pays',
    orderNote: 'Note de commande',
    orderNoteOptional: '(Optionnel)',
    orderNotePlaceholder: 'Si vous avez une note spéciale concernant votre commande...',
    saveAddressLabel: 'Enregistrer cette adresse pour la prochaine commande',
    savedAddressTitle: 'Votre adresse enregistrée',
    useSavedAddress: 'Utiliser l\'adresse enregistrée',
    shippingTitle: 'Options de livraison',
    freeShipping: 'Livraison gratuite',
    freeShippingDays: '5-7 jours ouvrables',
    freeShippingBadge: 'Gratuit',
    freeShippingNote: 'Valable pour toutes les commandes.',
    paymentTitle: 'Mode de paiement',
    creditCard: 'Carte crédit/débit',
    creditCardDesc: 'Visa, Mastercard, Amex',
    paypalDesc: 'Payer avec votre compte PayPal',
    iyzicoDesc: 'Infrastructure de paiement turque sécurisée',
    transfer: 'Virement bancaire',
    transferDesc: 'Payer par virement bancaire',
    cardInfo: 'Détails de la carte',
    cardName: 'Nom sur la carte',
    cardNamePlaceholder: 'NOM PRÉNOM',
    cardNumber: 'Numéro de carte',
    cardNumberPlaceholder: '0000 0000 0000 0000',
    cardExpiry: 'Date d\'expiration',
    cardExpiryPlaceholder: 'MM/AA',
    cardCvv: 'CVV',
    cardCvvPlaceholder: '•••',
    cardSecureNote: 'Vos données de carte sont sécurisées par chiffrement SSL 256 bits.',

    // Messages d'erreur de validation
    errFirstName: 'Le prénom est obligatoire',
    errLastName: 'Le nom est obligatoire',
    errEmail: 'L\'e-mail est obligatoire',
    errEmailInvalid: 'Entrez une adresse e-mail valide',
    errPhone: 'Le numéro de téléphone est obligatoire',
    errAddress: 'L\'adresse est obligatoire',
    errCity: 'La ville est obligatoire',
    errPostalCode: 'Le code postal est obligatoire',
    errCardName: 'Le nom sur la carte est obligatoire',
    errCardNumber: 'Entrez un numéro de carte valide',
    errCardExpiry: 'La date d\'expiration est obligatoire',
    errCardCvv: 'Le CVV est obligatoire',
    errTerms: 'Vous devez accepter les conditions générales',
    errCoupon: 'Code de réduction invalide',
    errCouponMinOrder: 'Le montant minimum pour ce coupon est {{amount}}',

    // Panier / récapitulatif
    orderSummaryTitle: 'Récapitulatif',
    products: 'articles',
    emptyCartMsg: 'Votre panier est vide',
    discountCode: 'Code de réduction',
    couponPlaceholder: 'ENTREZ LE CODE',
    apply: 'Appliquer',
    applied: 'Appliqué',
    couponApplied: 'Code de réduction appliqué!',
    couponAutoApplied: 'Code coupon appliqué automatiquement!',
    couponAutoAppliedDesc: 'le code a été ajouté à votre remise.',
    subtotal: 'Sous-total',
    shipping: 'Livraison',
    free: 'Gratuit',
    discount: 'Réduction',
    total: 'Total',
    vatIncluded: 'TVA incluse',
    sslSecure: 'SSL Sécurisé',
    easyReturn: 'Retour facile',
    qty: 'Qté',

    // Formulaire / envoi
    termsText: 'Conditions générales',
    privacyText: 'Politique de confidentialité',
    termsAccept: 'lus et acceptés.',
    termsAnd: 'et',
    submitting: 'Traitement de la commande...',
    submitOrder: 'Finaliser la commande',
    emptyCart: 'Votre panier est vide.',
    startShopping: 'Commencer les achats',

    // Paiement express
    expressCheckout: 'Paiement Express',
    orPayWith: 'ou payer avec',
    shopPayDesc: 'Payer avec votre compte Google',
    shopPaySubtitle: 'Infrastructure de paiement sécurisée de Google',
    shopPayFeature1: 'Paiement en un clic',
    shopPayFeature2: 'Totalement sécurisé avec chiffrement SSL 256 bits',
    shopPayFeature3: 'Paiement flexible avec Shop Pay Installments',
    shopPayContinue: 'Continuer avec Shop Pay',
    shopPayRedirect: 'Vous serez redirigé vers Shop Pay lors de la confirmation.',
    googlePayDesc: 'Payer avec votre compte Google',
    googlePayTitle: 'Paiement rapide avec Google Pay',
    googlePayNote: 'Payez en quelques secondes avec la carte liée à votre compte Google.',
    googlePayFeature1: 'Lié à votre compte Google',
    googlePayFeature2: 'Vérification par empreinte ou reconnaissance faciale',
    googlePayFeature3: 'Infrastructure mondiale valide dans 130+ pays',
    googlePayRedirect: 'Le paiement sera traité via l\'infrastructure sécurisée de Google.',

    // PayPal
    paypalTitle: 'Paiement sécurisé avec PayPal',
    paypalNote: 'Vous serez redirigé vers la page PayPal lors de la confirmation.',
    paypalProtection: 'Protection acheteur PayPal active',

    // iyzico
    iyzicoTitle: 'Paiement sécurisé avec iyzico',
    iyzicoNote: 'Infrastructure de paiement turque de confiance.',
    iyzico3d: '3D Secure',
    iyzicoInstallment: 'Paiement en plusieurs fois',
    iyzicoPci: 'PCI DSS',

    // Virement bancaire
    bankAccountTitle: 'Coordonnées bancaires',
    accountHolder: 'Titulaire du compte',
    iban: 'IBAN',
    transferNote: 'N\'oubliez pas d\'indiquer votre numéro de commande dans la description du virement.',

    // Page de succès
    successTitle: 'Commande reçue! 🎉',
    successSubtitle: 'Merci! Votre commande a été passée avec succès et est en cours de préparation.',
    orderNumberLabel: 'Votre numéro de commande',
    orderNumberNote: 'Notez ce numéro pour suivre votre commande.',
    estimatedDelivery: 'Livraison estimée',
    businessDays: 'Jours ouvrables',
    paymentLabel: 'Paiement',
    confirmEmail: 'E-mail de confirmation',
    confirmEmailSent: 'Envoyé',
    orderDetails: 'Détails de la commande',
    deliveryAddress: 'Adresse de livraison',
    orderProcess: 'Statut de la commande',
    stepReceived: 'Commande reçue',
    stepPreparing: 'En préparation',
    stepShipped: 'Expédiée',
    stepDelivered: 'Livrée',
    backHome: 'Retour à l\'accueil',
    continueShopping: 'Continuer les achats',
    contactUs: 'service client',
    contactNote: 'Pour toute question, contactez notre',
    contactEnd: '.',
    paymentCreditCard: 'Carte de crédit',
    paymentTransfer: 'Virement bancaire',
  },
};

export default common;
